<template lang="pug">
div
    el-form.demo-form-inline(:inline='true', :model='searchlist', size='mini')
        el-form-item(label='人员类别：', prop='personType')
            el-cascader(ref='searchArea',:props="optionProps" :options='orgTree', v-model='searchAreas', @change='handleChange', style='width:200px',:show-all-levels="false", change-on-select)

    el-table(ref='multipleTablePeo', :data='tableData', :row-key="getRowKey",@selection-change="selectionChange"
     :header-cell-style="{ background: '#f8fafa' }", border='', align='center', current-row-key='', highlight-current-row='', 
      @select="handleSelectionsChange" @select-all="handleSelectionsChange")
        el-table-column(type='selection', align='center' ,:selectable="checkSelectable" )
        el-table-column(align='center', prop='name', label='姓名')
        el-table-column(align='center', prop='sex', label='性别')
        el-table-column(align='center', prop='numberId', label='身份证号', width='250px')
        el-table-column(align='center', prop='phone', label='手机号')

    el-pagination(@size-change='handleSizeChange', @current-change='handleCurrentChange', :current-page='pageConfig.pageNo', :page-sizes='[10, 20, 30, 50]', :page-size='pageConfig.pageSize', layout='total, sizes, prev, pager, next, jumper', :total='pageConfig.total')
 
</template>

<script>
import request from "../../../../utils/request.js";
import {
  getConsulTYpePersion,
  getTypeById_p,
  getConsulPersonTree
} from "@/api/http.js";
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  name: "ViewPeople",
  props: ["fatherdata", "isshow"],
  data() {
    return {
      searchAreas: [],
      orgTree: [],
      optionProps: {
        value: "id",
        label: "consultName"
      },
      //人员类别
      searchGroups: [],
      searchlist: {},
      tableData: [],
      multipleSelection: {},
      // 分页配置
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      getRowKey(row) {
        return row.id;
      },

      checkSelectable(row) {
        return true;
      },
      checkedData: [],
      multipleSelectionFarher: {},
      multipleSelectionClick: {}
      //   surplusData: []
    };
  },
  methods: {
    //条件筛选中，区域选择赋值
    handleChange(value) {
      //   console.log(this.$refs.searchArea.getCheckedNodes()[0].data);
      var areas = this.$refs.searchArea.getCheckedNodes()[0].pathLabels;
      var id = this.$refs.searchArea.getCheckedNodes()[0].data.id;
      this.resetdata();
      this.getPageDatas();
    },
    //获取人员类别树状图
    async getPTypes() {
      var res = await getConsulPersonTree({
        // pageNo: 1,
        // pageSize: 9999,
        // parentId: 0
      });
      if (res.content && res.content.length) {
        this.orgTree = res.content || [];
      }
      this.getPageDatas();
    },

    //获取列表数据
    async getPageDatas() {
      this.$nextTick(() => {
        this.$refs.multipleTablePeo.clearSelection();
      });

      var res = await getConsulTYpePersion({
        pageNo: this.pageConfig.pageNo,
        pageSize: this.pageConfig.pageSize,
        personType: this.searchAreas[this.searchAreas.length - 1]
      });

      // console.log(res)
      if (res.code == 200) {
        this.pageConfig.total = res.content.count;
        this.tableData = res.content.list;

        if (res.content.list.length) {
          // 取出当前页数的选中table数据
          let hadTableData = [];
          if (this.choosedata && this.choosedata.length) {
            this.choosedata.forEach(row => {
              res.content.list.forEach(row1 => {
                if (row.id == row1.id) {
                  //   this.checkedData.push(row1);
                  hadTableData.push(row1);
                }
              });
            });
          }

          this.multipleSelectionFarher[this.pageConfig.pageNo] = hadTableData;
          //   第一次显示父级传进来的数据的回显,如果有选中则以实际为准
          //   console.log(this.multipleSelectionClick[this.pageConfig.pageNo]);
          if (!this.multipleSelectionClick[this.pageConfig.pageNo]) {
            this.multipleSelection[this.pageConfig.pageNo] = hadTableData;
          }

          let newpagedata = [];
          res.content.list.forEach(row1 => {
            this.multipleSelection[this.pageConfig.pageNo].forEach(row2 => {
              if (row1.id == row2.id) {
                //   this.checkedData.push(row1);
                newpagedata.push(row1);
              }
            });
          });
          this.multipleSelection[this.pageConfig.pageNo] = newpagedata;
          this.checkedData = newpagedata;
          this.checkedTable();
        }
      } else {
        // console.log(res);
        this.$message({
          message: "数据加载异常：",
          type: "error"
        });
      }
    },
    checkedTable() {
      //   console.log("checkedData==t", this.checkedData);
      this.$nextTick(() => {
        this.checkedData.forEach(checked => {
          this.$refs.multipleTablePeo.toggleRowSelection(checked, true);
        });
      });
    },

    handleSelectionsChange(val) {
      this.multipleSelectionClick[this.pageConfig.pageNo] = val.length + 1;
      this.multipleSelection[this.pageConfig.pageNo] = val;
      this.createData();
    },
    selectionChange(val) {
      // console.log(val);
    },
    //每页展示条数
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getPageDatas();
    },
    resetdata() {
      this.pageConfig.pageNo = 1;
      this.checkedData = [];
      this.multipleSelection = {};
      this.multipleSelectionFarher = {};
      this.multipleSelectionClick = {};
    },
    //封装数据
    createData() {
      let newdata = [];
      for (const key in this.multipleSelection) {
        if (this.multipleSelection.hasOwnProperty(key)) {
          newdata = newdata.concat(this.multipleSelection[key]);
        }
      }

      this.$emit("func", newdata);
    }
  },
  mounted() {
    this.getPTypes();
  },
  watch: {
    isshow(val) {
        console.log(val);
        
      if (!val) {
        this.checkedData = [];
        this.multipleSelection = {};
        this.multipleSelectionFarher = {};
        this.multipleSelectionClick = {};
        this.searchlist = {};
        this.tableData = [];
        this.pageConfig.pageNo = 1;
      } else {
        this.getPTypes();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.boontbtn {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
</style>